import React, { useEffect, useState } from 'react'
import {
  AboutCompany,
  DirectInternShips,
  InfoBlock,
  InternShipsVacation,
  InterShipsVolginsky,
  QuestionInterShips,
  SixSteps,
  TeachWithGenerium,
  Terms,
  WhyGeneriumInternShips,
  YourApply,
  YourQuestion,
  StudentInternShipsReviews
} from './index'

import logo from '../../../images/internShips/logo.png'
import logoWebP from '../../../images/internShips/logo.webp'


import styles from './styles.module.scss'
import smoothscroll from 'smoothscroll-polyfill'

const InternShips = ({ ourRef, setActivePopUp, checkDomenNameState, captchaSiteKey }) => {
  smoothscroll.polyfill()
  const [checkRef, setCheckRef] = useState('')

  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])

  const [refForm, setRefForm] = useState('')

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_image_block}>
        <div className={styles.wrapper_image}>
          <div className={styles.marquee_item}>
          <picture>
            <source type="image/webp" srcSet={logoWebP} alt="marquee" />
            <img src={logo} alt="marquee" />
          </picture>
          </div>
          <div className={styles.marquee_item}>
          <picture>
            <source type="image/webp" srcSet={logoWebP} alt="marquee" />
            <img src={logo} alt="marquee" />
          </picture>
          </div>
        </div>
      </div>

      <InfoBlock setActivePopUp={setActivePopUp} />
      {/*<AboutCompany />*/}
      <WhyGeneriumInternShips />
      <InterShipsVolginsky />
      <DirectInternShips refForm={refForm} />
      <Terms />
      <SixSteps />
      <StudentInternShipsReviews />
      {/* <YourApply checkDomenNameState={checkDomenNameState} setCheckRef={setCheckRef} captchaSiteKey={captchaSiteKey}  /> */}
      {/*<InternShipsVacation />*/}
      <QuestionInterShips />
      {/*<YourQuestion />*/}
      <TeachWithGenerium />
    </div>
  )
}

export default InternShips
